import React, { useState,useContext, useEffect } from "react";
import { LuSearch } from "react-icons/lu";
import { TbUser } from "react-icons/tb";
import { FaStar } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";

import { PiBriefcaseLight } from "react-icons/pi";
import "./JobDetails.scss";
import dummy from "../../assets/images/user.png";
//import { GridView } from "../candidatesView/GridView";
import { Details } from "../candidateDetails/details";
import { HiArrowLongLeft } from "react-icons/hi2";
import { CandidateForm } from "../candidateForm/candidateForm";
import { AuthContext } from "../../context/AuthContext";
import { AddProfileGridView } from "./AddProfileGridView";
import masterApi from "../../services/masterApi";

export default function AddProfile({ closePopup,jobId ,reloadData}) {
  const [isAddProfile, setIsAddProfile] = useState(true);
  const [isDetailsPopupVisible, setIsDetailsPopupVisible] = useState(false);
  const [isCreateCandidatePopupVisible, setIsCreateCandidatePopupVisible] = useState(false);
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);  
  const [locationSearch, setLocationSearch] = useState(null);
  const [technologySearch, setTechnologySearch] = useState(null);
  const [technologyLst, setTechnologyLst] = useState([]);
  let technologyformattedData = [];
  const [locationLst, setLocationLst] = useState([]);
  let locationformattedData = [];
  const [searchText, setSearchText] = useState("");
  const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;
  const [debouncedSearchText, setDebouncedSearchText] = useState("");

  const showDetailsPopup = (id) => {
    // debugger;
    setIsAddProfile(false)
    setIsDetailsPopupVisible(true);
    if(id){
      setCandidateIdValue(id);
    }    
  };

  const backToAddProfile = () => {
    setIsDetailsPopupVisible(false);
    setIsAddProfile(true)

  };
  const createProfile = () => {
    setIsAddProfile(false)

    setIsCreateCandidatePopupVisible(true);
  };

  const hidecreateProfilePopup = () => {
    setIsCreateCandidatePopupVisible(false);
    setIsAddProfile(true)

  };

  const handleLocationChange = (e) => {
    if(e.target.value === "All") {
      setLocationSearch(null);
    }
    else{ 
      setLocationSearch(e.target.value);
    }
  }

  const handleTechnologyChange = (e) => {
    if(e.target.value === "All") {
      setTechnologySearch(null);
    }
    else{ 
      setTechnologySearch(e.target.value);
    }
  }
  const loadTechnology = async () => {
    try {
      const response = await masterApi.getActiveSkill();
      // Transform the data
      const technologyformattedData = response?.data?.activeSkillList?.map((technology) => ({
        label: technology.skillName,
        value: technology.id
      }));
      setTechnologyLst(technologyformattedData);
    } catch (error) {
      console.error("Error loading technology:", error);
      setTechnologyLst([]);
    }
  };

  const loadLocation = async () => {
    try {
      const response = await masterApi.getAllCountry();
      // Transform the data
      const locationformattedData = response?.data?.map((location) => ({
        label: location.name,
        value: location.id
      }));
      setLocationLst(locationformattedData);
    } catch (error) {
      console.error("Error loading location:", error);
      setLocationLst([]);
    }
  };

  useEffect(() => {   
      const loadData = async () => {
          try {
              loadTechnology(); 
              loadLocation();
          } catch (error) {
              console.error("Error loading data:", error);
          }
      }
  const fetchAll = async () => {
      await loadData();
    };
    fetchAll();
    }, []);

    const handleInputChange = (e) => setSearchText(e.target.value);
    useEffect(() => {
      if (searchText.length >= REACT_APP_SEARCH_TEXT_LIMIT) { 
        const handler = setTimeout(() => {
          setDebouncedSearchText(searchText);
        }, 500); // 500ms delay
        return () => {
          clearTimeout(handler);
        };
      } else {
        setDebouncedSearchText(""); // Optionally reset to an empty string if text length is below 3
      }
    }, [searchText]);

  return (
    <section>
      {/* add profile main popup */}
      {isAddProfile &&
        <div className="popup-container full-width-popup">
          <div
            className="shadeClose"
            onClick={() => {
              closePopup();
            }}
          ></div>
          <div className="popup-inner">
            <div className="inner-design">
              <div className="popup-header d-flex align-items-center gap2">
                <h2>Add Profile</h2>
                <button type="button" className="btn ms-auto btn-primary d-flex me-4" onClick={createProfile}>Create Profile</button>
                <button
                  type="button"
                  className="ms-auto close-btn"
                  onClick={() => {
                    closePopup();
                  }}
                >
                  <IoCloseOutline />
                </button>
              </div>

              

              <div className="popup-content full-height">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

                <div className="d-flex gap-3 align-items-center mb-3">
                  <select className="form-select w-180" aria-label="location" onChange={handleLocationChange}>
                    <option defaultValue>All</option>  
                    {locationLst.map(location => (
                    <option key={location.value} value={location.value}>
                      {location.label}
                    </option>
                    ))}                             
                  </select>
                  <select className="form-select w-180" aria-label="tags" onChange={handleTechnologyChange}>
                    <option defaultValue>All</option>     
                    {technologyLst.map(technology => (
                    <option key={technology.value} value={technology.value}>
                      {technology.label}
                    </option>
                    ))}                      
                  </select>
                </div>
                
              {/* Search box on the right */}
                <div className="search-container position-relative">
                <div className="input-group search-container">
                  <input type="text" className="form-control" placeholder='Search' value={searchText}
                   onChange={handleInputChange} />
                  <button type="button" className="btn plain-btn-secondary"><LuSearch /></button>
                  </div>
                </div>
              </div>
               <br></br>
                {/* <GridView detailsPopup={showDetailsPopup} jobID={jobId} reloadData={reloadData} isCandidateView={false}/> */}
                <AddProfileGridView detailsPopup={showDetailsPopup} jobID={jobId} reloadData={reloadData} 
                locationSearch={locationSearch} technologySearch={technologySearch} searchValue={searchText}/>
              </div>
            </div></div>
        </div>
      }
      {/* profile details popup */}
      {isDetailsPopupVisible &&
        <div className="popup-container full-width-popup ">
          <div
            className="shadeClose"
            onClick={() => {
              backToAddProfile();
            }}
          ></div>
          <div className="popup-inner">
            <div className="inner-design">
              <div className="popup-header d-flex align-items-center gap2">
                <button className="plain-btn back-btn me-2" onClick={() => {
                  backToAddProfile();
                }}>
                  <HiArrowLongLeft />
                </button>
                <h2>Candidate Details</h2>
                <button
                  type="button"
                  className="ms-auto close-btn"
                  onClick={() => {
                    backToAddProfile();
                  }}
                >
                  <IoCloseOutline />
                </button>
              </div>

              <div className="popup-content full-height">
                <Details />
              </div>
            </div></div>
        </div>
      }
      {/* create profile popup */}
      {isCreateCandidatePopupVisible &&
        <CandidateForm closePopup={hidecreateProfilePopup} />
      }
    </section>

  );
}
